import { GridCellProps } from '@progress/kendo-react-grid';
import { flatten } from 'lodash';
import { useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import PopUp from 'src/components/design-system/PopUp';
import { errorIcon, warningIcon } from 'src/utils/icons';
import { useContextSelector } from 'use-context-selector';
import { InvoiceContext } from '../InvoiceDetailsContext';

const GlCodeInfo = (props: GridCellProps) => {
  const errors = useContextSelector(InvoiceContext, (value) => value.errors.glBreakout);
  const warnings = useContextSelector(InvoiceContext, (value) => value.warnings.glBreakout);

  const { dataIndex } = props;
  const errorMessages = useMemo(
    () => (errors?.[dataIndex] ? flatten(Object.values(errors?.[dataIndex])) : []),
    [dataIndex, errors]
  );

  const warningMessages = useMemo(
    () => (warnings?.[dataIndex] ? flatten(Object.values(warnings?.[dataIndex])) : []),
    [dataIndex, warnings]
  );

  return (
    <GridCellBase {...props} className="overflow-visible-imp">
      {errorMessages.length || warningMessages.length ? (
        <PopUp
          content={
            <div className="flex flex-col gap-2">
              <PopUpContentWrapper type="Error" contents={errorMessages} />
              <PopUpContentWrapper type="Warning" contents={warningMessages} />
            </div>
          }
        >
          <div className="flex justify-center items-center">
            {errorMessages.length ? errorIcon : warningIcon}
          </div>
        </PopUp>
      ) : (
        ''
      )}
    </GridCellBase>
  );
};

export default GlCodeInfo;
